/**
 * The TheBBSystem mark: a lowercase "bb" monogram on a primary-blue tile with a cyan dot.
 * `variant` picks one of the candidate marks (see docs/design/logo-options.svg); the monogram (B) was chosen on 2026-10-17.
 */
export function LogoMark({ size = 32, variant = 'monogram' }: { size?: number; variant?: 'boxes' | 'monogram' | 'tag' }) {
  if (variant === 'monogram') {
    return (
      <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
        <rect width="40" height="40" rx="10" fill="#1f3bb3" />
        <text x="20" y="27" textAnchor="middle" fontFamily="Inter, ui-sans-serif, system-ui" fontWeight="800" fontSize="20" fill="#fff" letterSpacing="-1">bb</text>
        <circle cx="31" cy="11" r="3.5" fill="#52cdff" />
      </svg>
    );
  }
  if (variant === 'tag') {
    return (
      <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
        <path d="M6 10a4 4 0 0 1 4-4h12l12 12-14 14L6 20Z" fill="#1f3bb3" />
        <circle cx="14" cy="14" r="3" fill="#52cdff" />
        <path d="M18 24l4-4 4 4-4 4Z" fill="#a3c7f5" />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
      <rect x="4" y="4" width="32" height="32" rx="9" fill="#1f3bb3" />
      <path d="M13 11h9.5a5 5 0 0 1 0 10H13Z" fill="#fff" />
      <path d="M13 21h11a5 5 0 0 1 0 10H13Z" fill="#fff" />
      <path d="M13 11v20" stroke="#52cdff" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  );
}

export function LogoWordmark({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex items-center gap-2.5">
      <LogoMark size={32} />
      {!compact && (
        <div className="leading-tight">
          <div className="text-[15px] font-bold tracking-tight text-ink">
            TheBB<span className="text-primary">System</span>
          </div>
          <div className="text-[10px] font-medium uppercase tracking-wider text-muted">Borg & Bigum</div>
        </div>
      )}
    </div>
  );
}
